export default __webpack_public_path__ + "static/media/Q2_3_resized.4eebbff3.jpg";